import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useToasts } from "../LayoutComponents/ToastContext";
import i18n from "../Services/i18n";
import styles from "./CancelChangeEmail.module.css";
import LoadingSpinner from "../LayoutComponents/LoadingSpinner";
import AccountService from "../Services/accountService";

const CancelChangeEmailPage = () => {
  const location = useLocation();
  const { addToast } = useToasts();
  const [msgCode, setMsgCode] = useState("");

  const hasRun = useRef(false);
  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    let isMounted = true;

    const run = async () => {
      const params = new URLSearchParams(location.search);

      if (!params.has("x") || !params.has("z")) {
        addToast(i18n.t("ChangeEmailConfirmationPage.Error"), "GENERIC", "ERROR", true);
        if (isMounted) {
          setMsgCode("param");
        }
      } else {
        try {
          const result = await AccountService.CancelChangeEmail(params.get("x"), params.get("z"));
          if (isMounted) setMsgCode(result);
        } catch (error) {
          console.error("Email confirmation error:", error);
          if (isMounted) {
            setMsgCode("failed");
            addToast(i18n.t("ChangeEmailConfirmationPage.Error"), "GENERIC", "ERROR", true);
          }
        }
      }
    };

    run();
  }, [location.search, addToast]);

  const getMsg = () => {
    switch (msgCode) {
      case "param":
        return i18n.t("CancelChangeUsername.param");
      case "burned":
        return i18n.t("CancelChangeUsername.burned");
      case "succeed":
        return i18n.t("CancelChangeUsername.succeed");
      default:
        return i18n.t("CancelChangeUsername.failed");
    }
  };

  return (
    <div>
      <div className={styles.container}>
        <div className={styles.loginWrapper}>
          <div className={styles.equestrologLogo}>Equestrolog</div>
          <div className={styles.box}>
            {msgCode && (
              <div>
                <span className={msgCode === "succeed" ? styles.succeed : styles.failed}>{getMsg()}</span>
                <br />
                <br />
                <a href="/login">Aller à la page de connexion</a>
              </div>
            )}
          </div>
        </div>
      </div>
      {msgCode === "" && (
        <div className={styles.savingOverlay}>
          <LoadingSpinner />
        </div>
      )}
    </div>
  );
};

export default CancelChangeEmailPage;
